import { makeFormData } from "./catalystFormDataBuilder";

const makeAxiosCatalystPostData = data => makeFormData(data);

const defaultAxiosCatalystPostConfig = {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
    }
}

export { makeAxiosCatalystPostData, defaultAxiosCatalystPostConfig }
